module.exports = __webpack_public_path__ + "img/loudspeaker.2fe5416f.svg";